import { Card } from 'antd';
import type { FC } from 'react';
import { useDepartments } from '@/common/useDepartments';
import type { GetOrderHistoryQuery } from '@/generated/graphql/graphql';
import dayjs from '@/utils/dayjs-instance';
import { RowView } from './components/RowChangeView';

export const OrderDriverInteractionView: FC<{
  driverOrderInteraction: GetOrderHistoryQuery['driver_order_interaction'][0];
}> = ({ driverOrderInteraction }) => {
  const { selectedDepartment } = useDepartments();
  const createdAtWithTimezone = dayjs
    .utc(driverOrderInteraction.createdAt)
    .utcOffset((selectedDepartment?.timeZone || 0) * 60);
  const createdAtDate = createdAtWithTimezone.format('DD, MMM');
  const createdAtTime = createdAtWithTimezone.format('HH:mm');
  const userName = driverOrderInteraction.user?.name;
  const contactType = driverOrderInteraction.contact_type as string;

  return (
    <div style={{ padding: '4px 8px' }}>
      <Card
        style={{ padding: 0 }}
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>{userName ?? 'Unknown driver'}</span>
            <div>
              <span style={{ color: '#1890ffaa', fontWeight: 400, fontSize: 14 }}>
                {createdAtDate}{' '}
              </span>
              <span style={{ color: '#1890ff' }}>{createdAtTime}</span>
            </div>
          </div>
        }
      >
        <div style={{ padding: 2 }}>
          <span>
            {RowView(`Driver tried to contact client via ${mapContactType(contactType)}`)}
          </span>
        </div>
      </Card>
    </div>
  );
};

function mapContactType(contactType: string) {
  switch (contactType) {
    case 'call':
      return 'Phone';
    case 'whatsapp':
      return 'Whatsapp';
  }
  return 'Unknown contact type';
}
